import React, { useState } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import "./Client.css";
// components imports
import FulfilmentTier from "./Components/FulfilmentTier/FulfilmentTier";
import ClientSettings from "./Components/ClientSettings/ClientSettings";
import ClientsTable from "../../../Components/BoltTable/BoltTable";
// apis imports
import {
  getUserWarehousesByWar_Id,
  approveWareHouseRequest,
} from "../../../services/warehouse.services";
// library imports
import { useSelector } from "react-redux";
import Tooltip from "../../../Components/Tooltip/Tooltip";
import { IconButton } from "@mui/material";
import { IoInformationCircleOutline } from "react-icons/io5";
import { MdOutlineEditCalendar, MdAdd, MdSettings } from "react-icons/md";
import SwitchButton from "../../../Components/SwitchButton/SwitchButton";
import StatusIcons from "../../../Components/StatusIcons/StatusIcons";
import WarehouseAddBalance from "./Components/AddBalance/AddBalance";
import { FcPlus } from "react-icons/fc";
import AddShipper from "./Components/AddShipper/AddShipper";
import { convertTime } from "../../../helpers/helpers";
import BoltButton from "../../../Components/UI/Buttons/BoltButton";
import { useTranslation } from "react-i18next";

const UserRegistration = () => {
  const { t } = useTranslation(["warehouse", "common"]);
  const [fulfilmenttierModal, setFulfilmenttierModal] = useState(false);

  const [users, setUsers] = useState([]);
  const [Change, setChange] = useState(false);
  const [addBalanceModal, setAddBalanceModal] = useState(false);
  const [addClientModal, setAddClientModal] = useState(false);
  const [settingsModal, setSettingsModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const setSnack = useSnackBar();
  const user = useSelector((state) => state.user);

  const isDefaultClient = (row) =>
    row?.warehouse?.current_user_id != null &&
    String(row?.shipper_id) === String(row?.warehouse?.current_user_id);

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("clients.userName"),
      render: (row) => <>{row?.shipper?.username ?? "-"}</>,
      width: "200px",
      fixed: "left",
    },
    {
      id: 2,
      label: t("clients.businessName"),
      render: (row) => <>{row?.shipper?.business_name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("clients.email"),
      render: (row) => <>{row?.shipper?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("common:fields.country"),
      render: (row) => <>{row?.shipper?.country ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("clients.state"),
      render: (row) => <>{row?.shipper?.province ?? "-"}</>,
      width: "200px",
    },
    {
      id: 6,
      label: t("clients.city"),
      render: (row) => <>{row?.shipper?.city ?? "-"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("clients.address"),
      render: (row) => <>{row?.shipper?.address ?? "-"}</>,
      width: "200px",
    },
    {
      id: 8,
      label: t("clients.balance"),
      render: (row) => <>{row?.balance ?? "-"}</>,
      width: "200px",
    },
    {
      id: 9,
      label: t("clients.type"),
      render: (row) => {
        if (isDefaultClient(row)) {
          return (
            <Tooltip title={t("clients.creatorOfThisWarehouse")}>
              <span>{t("clients.owner")}</span>
            </Tooltip>
          );
        }

        return (
          <Tooltip title={t("clients.clientOfThisWarehouse")}>
            <span>{t("clients.client")}</span>
          </Tooltip>
        );
      },
      width: "200px",
    },
    {
      id: 10,
      label: t("clients.status"),
      render: (row) => (
        <>
          <StatusIcons
            status={
              row?.is_approved === "false"
                ? "Pending"
                : row?.is_approved === "notapplied"
                  ? "Not Applied"
                  : row?.is_approved === "true"
                    ? "Approved"
                    : ""
            }
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 11,
      label: (
        <div>
          {t("clients.activate")}
          <Tooltip title={t("clients.approvedDisapproved")}>
            <IconButton>
              <IoInformationCircleOutline size={15} />
            </IconButton>
          </Tooltip>
        </div>
      ),
      render: (row, rowIndex, handleFieldChange) => (
        <div>
          <SwitchButton
            onChange={() => approveRequest(row)}
            checked={
              ![false, "false", "0", null, undefined].includes(row?.is_approved)
            }
            disabled={Change === "activate" ? true : false}
          />
        </div>
      ),
      width: "200px",
    },
    {
      id: 12,
      label: t("clients.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 13,
      label: t("clients.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          <Tooltip title={t("clients.viewFulfillmentTier")}>
            <div
              className="table_action__btn"
              onClick={() => setFulfilmenttierModal(row)}
            >
              <MdOutlineEditCalendar
                size={10}
                style={{
                  cursor: "pointer",
                }}
              />
              <span>{t("clients.tier")}</span>
            </div>
          </Tooltip>
          <Tooltip title={t("clients.viewFulfillmentTier")}>
            <div
              className="table_action__btn"
              onClick={() => setAddBalanceModal(row)}
            >
              <MdAdd
                size={10}
                style={{
                  cursor: "pointer",
                }}
              />
              <span>{t("clients.addBalance")}</span>
            </div>
          </Tooltip>
          <Tooltip title={t("clients.clientSettings")}>
            <div
              className="table_action__btn"
              onClick={() => setSettingsModal(row)}
            >
              <MdSettings
                size={10}
                style={{
                  cursor: "pointer",
                }}
              />
              <span>{t("clients.settings")}</span>
            </div>
          </Tooltip>
        </div>
      ),
      width: "260px",
      fixed: "right",
    },
  ];

  const fetchWareHouseClientsList = async (page, perPage, filter) => {
    const response = await getUserWarehousesByWar_Id(
      user?.warehouse_id,
      page,
      perPage,
      filter,
    );
    if (!response.error) {
      setUsers(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const approveRequest = async (row) => {
    setChange("activate");
    const saved = await approveWareHouseRequest(
      row?.id,
      row?.is_approved === "true" ? "false" : "true",
    );
    if (!saved.error) {
      setUsers((prevUser) => {
        return {
          ...prevUser,
          data: prevUser?.data.map((user, index) => {
            if (user.id === row.id) {
              return {
                ...user,
                is_approved: saved?.data?.result?.is_approved,
              };
            }
            return user;
          }),
        };
      });
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("clients.statusChanged", {
            username: row?.shipper?.username,
            status: [false, "false", "0", null, undefined].includes(row?.is_approved)
              ? t("clients.statusActive")
              : t("clients.statusInactive"),
          }),
          severity: [false, "false", "0", null, undefined].includes(
            row?.is_approved,
          )
            ? "success"
            : "info",
        };
      });
      setChange(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: saved?.error?.response?.data?.message ?? t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setChange(false);
    }
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "5px 5px" }}
    >
      <FulfilmentTier
        open={fulfilmenttierModal}
        setOpen={setFulfilmenttierModal}
        setSnack={setSnack}
      />
      <WarehouseAddBalance
        open={addBalanceModal}
        setOpen={setAddBalanceModal}
        setSnack={setSnack}
        setTableData={setUsers}
        tableData={users}
      />
      <AddShipper
        open={addClientModal}
        setOpen={setAddClientModal}
        setSnack={setSnack}
        setRefresh={setRefresh}
      />
      <ClientSettings
        open={settingsModal}
        setOpen={setSettingsModal}
        setSnack={setSnack}
        onClientUpdated={(updated) => {
          if (!updated?.id) return;
          // Patch the matching row in the clients list with new permissions etc.
          setUsers((prev) => {
            if (Array.isArray(prev?.data)) {
              return {
                ...prev,
                data: prev.data.map((u) =>
                  u.id === updated.id ? { ...u, ...updated } : u,
                ),
              };
            }
            if (Array.isArray(prev)) {
              return prev.map((u) =>
                u.id === updated.id ? { ...u, ...updated } : u,
              );
            }
            return prev;
          });
          // Keep the modal pointed at the freshly-updated row so initial
          // selection stays in sync if user toggles again.
          setSettingsModal((current) =>
            current && current.id === updated.id
              ? { ...current, ...updated }
              : current,
          );
        }}
      />
      <div>
        <ClientsTable
          tableTitle={t("clients.clients")}
          tableId="clientsTableforWarehouse"
          message={t("clients.noClientsAvailableToDisplay")}
          searchPlaceHolder={t("clients.searchClients")}
          columns={columns}
          data={users}
          getAllData={fetchWareHouseClientsList}
          refresh={refresh}
          headerButtons={
            <div className="flex gap-1 flex-wrap">
              <BoltButton
                icon={FcPlus}
                label={t("clients.addClient")}
                onClick={() => setAddClientModal(true)}
                variant="success"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default UserRegistration;
